import type { GridColDef } from '@mui/x-data-grid';
import type { GetArAgingReportResponse } from '@weft/api-definition';
import { OUTSTANDING_BREAKDOWN_OPTIONS } from '@weft/api-definition';
import type { ItemOf } from '@weft/utils';
import { withDefault } from '@weft/utils';
import { Price } from '../../../../../components/design/Price';
import { VyTableCell } from '../../../../../components/new-design/table/vy-table/VyTableCell';

const AR_AGING_REPORT_KEYS = Object.freeze({
  CUSTOMER_NAME: 'customerName',
  TOTAL_GROSS_AMOUNT: 'totalGrossAmount',
  UP_TO_ONE_MONTH: 'upToOneMonth',
  ONE_TO_TWO_MONTHS: 'oneToTwoMonths',
  TWO_TO_THREE_MONTHS: 'twoToThreeMonths',
  MORE_THAN_THREE_MONTHS: 'moreThanThreeMonths',
} satisfies Record<string, string>);

export const AR_AGING_REPORT_TABLE_COLUMNS: GridColDef<ItemOf<GetArAgingReportResponse['summary']>>[] = [
  {
    field: AR_AGING_REPORT_KEYS.CUSTOMER_NAME,
    headerName: 'Customer Breakdown',
    valueGetter: (params) => params.row.customer.name,
    minWidth: 240,
    flex: 1,
    headerClassName: 'pl-6',
    renderCell: ({ row: { customer: { name } } }) => (
      <VyTableCell
        value={name}
        containerClassName='justify-start pl-4'
      />
    ),
  },
  {
    field: AR_AGING_REPORT_KEYS.UP_TO_ONE_MONTH,
    headerName: '1-30',
    headerAlign: 'center',
    valueGetter: (params) => withDefault(params.row.outstandingBreakdown[OUTSTANDING_BREAKDOWN_OPTIONS.UP_TO_ONE_MONTH]?.grossAmount, 0),
    minWidth: 240,
    flex: 1,
    renderCell: ({ row: { outstandingBreakdown } }) => (
      <VyTableCell
        value={(
          <Price>
            {withDefault(outstandingBreakdown[OUTSTANDING_BREAKDOWN_OPTIONS.UP_TO_ONE_MONTH]?.grossAmount, 0)}
          </Price>
        )}
        containerClassName='justify-center'
      />
    ),
  },
  {
    field: AR_AGING_REPORT_KEYS.ONE_TO_TWO_MONTHS,
    headerName: '31-60',
    headerAlign: 'center',
    valueGetter: (params) => withDefault(params.row.outstandingBreakdown[OUTSTANDING_BREAKDOWN_OPTIONS.ONE_TO_TWO_MONTHS]?.grossAmount, 0),
    minWidth: 240,
    flex: 1,
    renderCell: ({ row: { outstandingBreakdown } }) => (
      <VyTableCell
        value={(
          <Price>
            {withDefault(outstandingBreakdown[OUTSTANDING_BREAKDOWN_OPTIONS.ONE_TO_TWO_MONTHS]?.grossAmount, 0)}
          </Price>
        )}
        containerClassName='justify-center'
      />
    ),
  },
  {
    field: AR_AGING_REPORT_KEYS.TWO_TO_THREE_MONTHS,
    headerName: '61-90',
    headerAlign: 'center',
    valueGetter: (params) => withDefault(params.row.outstandingBreakdown[OUTSTANDING_BREAKDOWN_OPTIONS.TWO_TO_THREE_MONTHS]?.grossAmount, 0),
    minWidth: 240,
    flex: 1,
    renderCell: ({ row: { outstandingBreakdown } }) => (
      <VyTableCell
        value={(
          <Price>
            {withDefault(outstandingBreakdown[OUTSTANDING_BREAKDOWN_OPTIONS.TWO_TO_THREE_MONTHS]?.grossAmount, 0)}
          </Price>
        )}
        containerClassName='justify-center'
      />
    ),
  },
  {
    field: AR_AGING_REPORT_KEYS.MORE_THAN_THREE_MONTHS,
    headerName: '91+',
    headerAlign: 'center',
    valueGetter: (params) => withDefault(params.row.outstandingBreakdown[OUTSTANDING_BREAKDOWN_OPTIONS.MORE_THAN_THREE_MONTHS]?.grossAmount, 0),
    minWidth: 240,
    flex: 1,
    renderCell: ({ row: { outstandingBreakdown } }) => (
      <VyTableCell
        value={(
          <Price>
            {withDefault(outstandingBreakdown[OUTSTANDING_BREAKDOWN_OPTIONS.MORE_THAN_THREE_MONTHS]?.grossAmount, 0)}
          </Price>
        )}
        containerClassName='justify-center'
      />
    ),
  },
];